<template>
  <div class="Trio-wrapper">
    <afford-header></afford-header>
    <div class="Trio-body">
      <afford-set-data
        v-if="step == 1"
        v-on:updateAfford="updateAfford"
        :errorText="errorText"
        :is-loading="loading"
      ></afford-set-data>
      <afford-results v-if="step == 2"></afford-results>
      <afford-form v-if="step == 3"></afford-form>
      <congratulations v-if="step == 4"></congratulations>
    </div>
  </div>
</template>

<script>
import affordHeader from "./affordHeader.vue";
import affordSetData from "./affordSetData.vue";
import affordResults from "./affordResults.vue";
import personalForm from "./personalForm.vue";
import { Store } from "../store/index.js";
import affordForm from "./affordForm.vue";
import congratulations from "./Congratulations.vue";
import { mapActions, mapState } from "vuex";
/* eslint-disable */

export default {
  name: "affordMortgage",
  components: {
    affordHeader,
    affordSetData,
    affordResults,
    personalForm,
    affordForm,
    congratulations,
  },
  data: function () {
    return {
      errorsResponse: null,
      errorCode: null,
      errorText: null,
    };
  },
  computed: {
    ...mapState("ui", ["loading"]),
    step() {
      return Store.getters["ui/step"];
    },
  },
  methods: {
    ...mapActions("mortgageAfford", ["updateAfford"]),
  },
};
</script>